import { render, staticRenderFns } from "./MyocardialInfarction.vue?vue&type=template&id=aa87a428&scoped=true"
import script from "./MyocardialInfarction.vue?vue&type=script&lang=js"
export * from "./MyocardialInfarction.vue?vue&type=script&lang=js"
import style0 from "./MyocardialInfarction.vue?vue&type=style&index=0&id=aa87a428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa87a428",
  null
  
)

export default component.exports